import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptUseViewStore } from "../../store";
import { PaymentReceiptUseViewForm } from "./PaymentReceiptUseViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PaymentReceiptUseViewProps = {
  paymentReceiptUseViewStore: PaymentReceiptUseViewStore;
};

export const PaymentReceiptUseView: React.FC<PaymentReceiptUseViewProps> =
  observer(({ paymentReceiptUseViewStore }) => {
    return (
      <div>
        <PaymentReceiptUseViewForm
          detail={paymentReceiptUseViewStore.detailValue}
          usedAt={paymentReceiptUseViewStore.usedAtValue}
          signedEditionValue={paymentReceiptUseViewStore.signedEditionValue}
          onPrint={(handlePrint: () => void) =>
            paymentReceiptUseViewStore.printPaymentReceiptUse(handlePrint)
          }
          onCancel={() => paymentReceiptUseViewStore.cancelPaymentReceiptUse()}
          onEdit={
            paymentReceiptUseViewStore.isEditEnabled
              ? () => paymentReceiptUseViewStore.editPaymentReceiptUse()
              : undefined
          }
        />
        <ErrorDialog
          open={paymentReceiptUseViewStore.errorDialogOpened}
          title={paymentReceiptUseViewStore.errorTitle}
          description={paymentReceiptUseViewStore.errorDescription}
          onClose={() => paymentReceiptUseViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
